<template>
  <pt-video-detail class="pt-video-detail__withData" v-loading="loading" :poster="currentPoster">></pt-video-detail>
</template>

<script>
import PtVideoDetail from './index'
export default {
  name: 'pt-video-detail__withData',
  components: {
    'pt-video-detail': PtVideoDetail
  },
  data () {
    return {
      loading: false,
      currentPoster: {}
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('getPosterDetail', this.$route.params.id).then(data => {
        this.loading = false
        this.currentPoster = data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
